import React, { useEffect, useState } from 'react';
import FramePlayer from '../utils/FramePlayer';
import '../css/button.css';
import anime from 'animejs';
import { Navigate, useNavigate } from 'react-router-dom';
import HomeButton from '../utils/HomeButton';

const Menu2 = ({audio, menuState}) => {

    const [b1hovered, setB1hovered] = useState(false);
    const [b2hovered, setB2hovered] = useState(false);
    const [b3hovered, setB3hovered] = useState(false);
    const [b4hovered, setB4hovered] = useState(false);
    const [b5hovered, setB5hovered] = useState(false);
    const [b6hovered, setB6hovered] = useState(false);

    const navigate = useNavigate()

    function clearAll() {
        // Get a reference to the last interval + 1
        const interval_id = window.setInterval(function () { }, Number.MAX_SAFE_INTEGER);

        // Clear any timeout/interval up to that id
        for (let i = 1; i < interval_id; i++) {
            window.clearInterval(i);
        }

        audio.forEach(audio => audio.pause());
    }

    useEffect(() => {
            clearAll();
            var tl = anime.timeline({});
            tl.add({
                targets: '.b',
                opacity: 0,
                duration: 0,
            }, 0)
                .add({
                    targets: '.note',
                    opacity: 1,
                    duration: 0,
                    easing: 'easeOutElastic(1, .8)',
                }, 0)
                .add({
                    targets: '#note1',
                    left: '210px',
                    top: '10px',
                    duration: 0,
                    easing: 'linear',
                }, 0)
                .add({
                    targets: '#note2',
                    left: '180px',
                    top: '20px',
                    duration: 0,
                    easing: 'linear',
                }, 0)
                .add({
                    targets: '#note3',
                    left: '210px',
                    top: '45px',
                    duration: 0,
                    easing: 'linear',
                }, 0)
                .add({
                    targets: '.note',
                    opacity: 0,
                    duration: 0,
                    easing: 'easeOutElastic(1, .8)',
                }, 0)
                .add({
                    targets: '.title',
                    opacity: 1,
                    duration: 0,
                    easing: 'linear',
                }, 0)
                .add({
                    targets: '.title',
                    left: '230px',
                    top: '10px',
                    fontSize: '2.6em',
                    duration: 0,
                    easing: 'linear',
                }, 0)
                .add({
                    targets: "#carte-img",
                    scale: 1,
                    duration: 0,
                    easing: 'linear'
                }, 0)
                .add({
                    targets: '.bouton1',
                    opacity: 1,
                    duration: 0,
                    easing: 'linear',
                }, 0)
                .add({
                    targets: '.bouton2',
                    opacity: 1,
                    duration: 0,
                    easing: 'linear',
                }, 0)
                .add({
                    targets: '.bouton3',
                    opacity: 1,
                    duration: 0,
                    easing: 'linear',
                }, 0)
                .add({
                    targets: '.bouton4',
                    opacity: 1,
                    duration: 0,
                    easing: 'linear',
                }, 0)
                .add({
                    targets: '.bouton5',
                    opacity: 1,
                    duration: 0,
                    easing: 'linear',
                }, 0)
                .add({
                    targets: '.bouton6',
                    opacity: 1,
                    duration: 0,
                    easing: 'linear',
                }, 0)
            

    }, []);

    return (
        <>
            <div className='background'
                style={
                    {
                        backgroundColor: '#ff802d',
                    }
                } />
            <div className='instrument'>
                <img src={process.env.PUBLIC_URL + "/assets/images/menu/instrument.jpg"}
                    style={{
                        position: 'absolute',
                        top: '20px',
                        left: '70px',
                    }} />
            </div>
            <div className='note' id='note1'
                style={{
                    position: 'absolute',
                    top: '30px',
                    left: '150px',
                    opacity: '0.1',
                }}>
                <img src={process.env.PUBLIC_URL + "/assets/images/menu/note.png"} />
            </div>
            <div className='note' id='note2'
                style={{
                    position: 'absolute',
                    top: '30px',
                    left: '150px',
                    opacity: '0.1',
                }}>
                <img src={process.env.PUBLIC_URL + "/assets/images/menu/note.png"} />
            </div>
            <div className='note' id='note3'
                style={{
                    position: 'absolute',
                    top: '30px',
                    left: '150px',
                    opacity: '0.1',
                }}>
                <img src={process.env.PUBLIC_URL + "/assets/images/menu/note.png"} />
            </div>
            <div className='title'
                style={{
                    position: 'absolute',
                    top: '20px',
                    left: '140px',
                    opacity: 0,
                }}
            >
                <h1
                    style={{
                        fontSize: '1em',
                        fontFamily: 'Arial',
                        fontWeight: 'normal',
                        color: '#000',
                    }}
                >
                    Clés d'écoute
                </h1>
            </div>
            {/* carte avec boutons */}
            <div id='carte'
                style={{
                    position: 'absolute',
                    top: '150px',
                    left: '100px',
                    zIndex: '3',
                }}
            >
                <img src={process.env.PUBLIC_URL + "/assets/images/menu/carte.png"}
                    id='carte-img'
                    style={{
                        opacity: b1hovered || b2hovered || b3hovered || b4hovered || b5hovered || b6hovered ? '0.5' : '1',
                        transform: 'scale(0)',
                    }} />
                {/* bouton 1 */}
                <div className="bouton1 b"
                    style={{
                        position: 'absolute',
                        top: '130px',
                        left: '208px',
                        zIndex: '4',
                        opacity: b2hovered || b3hovered || b4hovered || b5hovered || b6hovered ? '0.5' : '1',
                        cursor: 'pointer',
                    }}
                    onMouseEnter={() => {
                        setB1hovered(true);
                    }}
                    onMouseLeave={() => {
                        setB1hovered(false);
                    }}
                    onClick={() => {
                        window.parent.location.href = 'https://digitaljazz.fr/clesdecoute/' + '/nzakara'
                        //navigate(process.env.PUBLIC_URL + '/nzakara')
                    }}
                >
                    <img src={process.env.PUBLIC_URL + "/assets/images/menu/bouton.png"} />
                    <p
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            color: 'white',
                            fontWeight: 'bold',
                            margin: '0px',
                            width: 20,
                            height: 20,
                            textAlign: 'center',
                        }}>
                        1
                    </p>
                </div>
                <div className='explications1'
                    style={{
                        position: 'absolute',
                        top: '170px',
                        left: '0px',
                        width: '403px',
                        opacity: b1hovered ? 1 : 0,
                        textAlign: 'center'
                    }}>
                    <p>
                        Les mélodies jumelles de la harpe (Centrafrique) <br />
                        <span style={{ fontSize: "13px" }}>Marc Chemillier</span>
                    </p>
                </div>
                {/* bouton 2 */}
                <div className="bouton2 b"
                    style={{
                        position: 'absolute',
                        top: '140px',
                        left: '314px',
                        zIndex: '4',
                        opacity: b1hovered || b3hovered || b4hovered || b5hovered || b6hovered ? '0.5' : '1',
                        cursor: 'pointer',
                    }}
                    onMouseEnter={() => {
                        setB2hovered(true);
                    }}
                    onMouseLeave={() => {
                        setB2hovered(false);
                    }}
                    onClick={() => {
                        window.parent.location.href = 'https://digitaljazz.fr/clesdecoute/' + '/badong'
                        //navigate(process.env.PUBLIC_URL + '/badung')
                    }}
                >
                    <img src={process.env.PUBLIC_URL + "/assets/images/menu/bouton.png"} />
                    <p
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            color: 'white',
                            margin: '0px',
                            width: 20,
                            height: 20,
                            fontWeight: 'bold',
                            textAlign: 'center',
                        }}>
                        2
                    </p>
                </div>
                <div className='explications2'
                    style={{
                        position: 'absolute',
                        top: '170px',
                        left: '0px',
                        width: '403px',
                        opacity: b2hovered ? 1 : 0,
                        textAlign: 'center'
                    }}>
                    <p>
                        La ronde funéraire Badong (Indonésie) <br />
                        <span style={{ fontSize: "13px" }}>Dana Rappoport</span>
                    </p>
                </div>
                {/* bouton 3 */}
                <div className="bouton3 b"
                    style={{
                        position: 'absolute',
                        top: '86px',
                        left: '173px',
                        zIndex: '4',
                        opacity: b1hovered || b2hovered || b4hovered || b5hovered || b6hovered ? '0.5' : '1',
                        cursor: 'pointer',
                    }}
                    onMouseEnter={() => {
                        setB3hovered(true);
                    }}
                    onMouseLeave={() => {
                        setB3hovered(false);
                    }}
                    onClick={() => {
                        window.parent.location.href = 'https://digitaljazz.fr/clesdecoute/' +'/flamenco'
                        //navigate(process.env.PUBLIC_URL + '/compas')
                    }}
                >
                    <img src={process.env.PUBLIC_URL + "/assets/images/menu/bouton.png"} />
                    <p
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            color: 'white',
                            fontWeight: 'bold',
                            margin: '0px',
                            width: 20,
                            height: 20,
                            textAlign: 'center',
                        }}>
                        3
                    </p>
                </div>
                <div className='explications3'
                    style={{
                        position: 'absolute',
                        top: '170px',
                        left: '0px',
                        width: '403px',
                        opacity: b3hovered ? 1 : 0,
                        textAlign: 'center'
                    }}>
                    <p>
                        Le flamenco : la machine à compàs (Espagne) <br />
                        <span style={{ fontSize: "13px" }}>D'après un CD-ROM inédit de Philippe Donnier</span>
                    </p>
                </div>
                {/* bouton 4 */}
                <div className="bouton4 b"
                    style={{
                        position: 'absolute',
                        top: '88px',
                        left: '197px',
                        zIndex: '4',
                        opacity: b1hovered || b2hovered || b3hovered || b5hovered || b6hovered ? '0.5' : '1',
                        cursor: 'pointer',
                    }}
                    onMouseEnter={() => {
                        setB4hovered(true);
                    }}
                    onMouseLeave={() => {
                        setB4hovered(false);
                    }}
                    onClick={() => {
                        window.parent.location.href = 'https://digitaljazz.fr/clesdecoute/' +'/sardaigne'
                        //navigate(process.env.PUBLIC_URL + '/sardaigne')
                    }}
                >
                    <img src={process.env.PUBLIC_URL + "/assets/images/menu/bouton.png"} />
                    <p
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            color: 'white',
                            fontWeight: 'bold',
                            margin: '0px',
                            width: 20,
                            height: 20,
                            textAlign: 'center',
                        }}>
                        4
                    </p>
                </div>
                <div className='explications4'
                    style={{
                        position: 'absolute',
                        top: '170px',
                        left: '0px',
                        width: '403px',
                        opacity: b4hovered ? 1 : 0,
                        textAlign: 'center'
                    }}>
                    <p>
                        La quintina : polyphonie vocale (Sardaigne) <br />
                        <span style={{ fontSize: "13px" }}>Bernard Lortat-Jacob</span>
                    </p>
                </div>
                {/* bouton 5 */}
                <div className="bouton5 b"
                    style={{
                        position: 'absolute',
                        top: '80px',
                        left: '282px',
                        zIndex: '4',
                        opacity: b1hovered || b2hovered || b3hovered || b4hovered || b6hovered ? '0.5' : '1',
                        cursor: 'pointer',
                    }}
                    onMouseEnter={() => {
                        setB5hovered(true);
                    }}
                    onMouseLeave={() => {
                        setB5hovered(false);
                    }}
                    onClick={() => {
                        window.parent.location.href = 'https://digitaljazz.fr/clesdecoute/' +'/diphonique'
                        //navigate(process.env.PUBLIC_URL + '/diphonique')
                    }}
                >
                    <img src={process.env.PUBLIC_URL + "/assets/images/menu/bouton.png"} />
                    <p
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            color: 'white',
                            fontWeight: 'bold',
                            margin: '0px',
                            width: 20,
                            height: 20,
                            textAlign: 'center'
                        }}>
                        5
                    </p>
                </div>
                <div className='explications5'
                    style={{
                        position: 'absolute',
                        top: '170px',
                        left: '0px',
                        width: '403px',
                        opacity: b5hovered ? 1 : 0,
                        textAlign: 'center'
                    }}>
                    <p>
                        Le chant diphonique<br />
                        <span style={{ fontSize: "13px" }}>Tran Quang Hai</span>
                    </p>
                </div>

                {/* bouton 6 */}
                <div className="bouton6 b"
                    style={{
                        position: 'absolute',
                        top: '159px',
                        left: '232px',
                        zIndex: '4',
                        opacity: b1hovered || b2hovered || b3hovered || b4hovered || b5hovered ? '0.5' : '1',
                        cursor: 'pointer',
                    }}
                    onMouseEnter={() => {
                        setB6hovered(true);
                    }}
                    onMouseLeave={() => {
                        setB6hovered(false);
                    }}
                    onClick={() => {
                        window.parent.location.href = 'https://digitaljazz.fr/clesdecoute/'+'madagascar'
                        //navigate(process.env.PUBLIC_URL + '/madagascar/marovany-1-transe')
                    }}
                >
                    <img src={process.env.PUBLIC_URL + "/assets/images/menu/bouton.png"} />
                    <p
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            color: 'white',
                            fontWeight: 'bold',
                            margin: '0px',
                            width: 20,
                            height: 20,
                            textAlign: 'center'
                        }}>
                        6
                    </p>
                </div>
                <div className='explications6'
                    style={{
                        position: 'absolute',
                        top: '170px',
                        left: '0px',
                        width: '403px',
                        opacity: b6hovered ? 1 : 0,
                        textAlign: 'center'
                    }}>
                    <p>
                        La musique de transe pour cithare à Madagascar<br />
                        <span style={{ fontSize: "13px" }}>Marc Chemillier</span>
                    </p>
                </div>
            </div>
        </>
    )
}

export default Menu2;